export default "__VITE_ASSET__lMpsFPnx__"